export const GovMessageDisplay = ({ body }) => body



// WEBPACK FOOTER //
// ./src/ui/gov-messages/views/message.jsx